module.exports = __webpack_public_path__ + "static/media/LinkedIn.0f3b070f.svg";